<template>
  <div class="row animated fadeIn step-container">
    <div class="col-md-8 offset-md-2 step-body">
      <h4 class="step-header" v-if="isPendingView">{{$t('message.appointment.pending_view')}}</h4>
      <h4 class="step-header" v-else>{{$t('message.appointment.appointment_view')}}</h4>
      <div class='appointments-wrapper' v-if="!showAddPanel">
        <bs-input v-model='q' :placeholder="$t('message.appointment.search_appointment')"></bs-input>
        <div class='pagination'>
          <div><strong>{{$t('message.pagination.show')}}</strong> {{ paginator.from }} - {{ paginator.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ paginator.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
          <a class='btn' @click="paginator.prev_page_url && reloadAppointments(paginator.prev_page_url)" :class="{ enable: paginator.prev_page_url }">{{$t('message.pagination.prev')}}</a>
          <a class='btn' @click="paginator.next_page_url && reloadAppointments(paginator.next_page_url)" :class="{ enable: paginator.next_page_url }">{{$t('message.pagination.next')}}</a>
        </div>
        <div v-if="filtered_appointments.length > 0" >
          <transition-group name='list' tag='div'>
            <div class="appointment-container" v-for="(app, index) in filtered_appointments" :key="index">
              <div class='card appointment-content'>
                <div class='card-header'><span class='app-date'>{{ app.start }}</span><span class="badge badge-success">{{ app.object.status }}</span></div>
                <div class='card-block'>
                  <h6 class='app-name'>{{ app.object.firstname }} {{ app.object.lastname }}</h6>
                  <div class='app-phone'>{{ app.object.phone }}</div>
                  <div class='app-doctor'>{{ app.title }}</div>
                  <!--
                  <div class='appointments-actions'>
                    <i class="fa fa-pencil-square-o" @click="editAppointment(app)"></i>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </transition-group>
        </div>
        <h6 class="alert alert-warning" v-else>
          {{$t('message.appointment.no_appointment')}}
        </h6>
      </div>

      <div v-if="showAddPanel" class='appointment-form'>
        <h6>{{$t('message.appointment.add_appointment')}}</h6>

        <label for="fp"><strong>{{$t('message.appointment.appointment_date')}}</strong></label>
        <flat-pickr v-model='appointment.appointment_time'
                    id="fp"
                    :config="{enableTime: true, altInput: true, wrap: true, time_24hr: true}">
        </flat-pickr><br/>

        <bs-input :label="$t('message.appointment.firstname')" v-model="appointment.firstname" :placeholder="$t('message.appointment.firstname')"></bs-input>
        <bs-input :label="$t('message.appointment.lastname')" v-model="appointment.lastname" :placeholder="$t('message.appointment.lastname')"></bs-input>
        <bs-input :label="$t('message.appointment.phone')" v-model="appointment.phone" :placeholder="$t('message.appointment.phone')"></bs-input>
        <bs-input :label="$t('message.appointment.email')" v-model="appointment.email" :placeholder="$t('message.appointment.email')"></bs-input>
        <label>{{$t('message.appointment.duration')}}</label>
        <bs-input type="Number" class="input-min" min="1" max="59" v-model="appointment.duration" :placeholder="$t('message.appointment.duration')">
           <span slot="after" class="input-group-addon">
             <strong>{{$t('message.appointment.duration_unit')}}</strong>
           </span>
        </bs-input>
        <div class="form-divider"></div>
        <label>{{$t('message.appointment.service')}}</label>
        <multiselect id="service"
                    class="multi-select-form"
                    v-model="appointment.service" 
                    :placeholder="$t('message.appointment.service_placeholder')" 
                    :options="[{label: 'service', value: '1'}]" 
                    :allow-empty="true"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
        <label>{{$t('message.appointment.doctor')}}</label>
        <multiselect id="doctor"
                    class="multi-select-form"
                    v-model="appointment.doctor" 
                    :placeholder="$t('message.appointment.doctor')" 
                    :options="[{label: 'doctor1', value: '1'}]" 
                    :allow-empty="true"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
        <bs-input type="textarea" :label="$t('message.appointment.addition')" v-model="appointment.comment" :placeholder="$t('message.appointment.addition')"></bs-input>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-lg btn-close" @click="cancelAddingAppointment">{{$t('action_message.cancel')}}</button>
            <button class="btn btn-add btn-lg btn-success" @click="addAppointment">{{ editMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
            <button v-if="editMode" class="btn btn-add btn-lg btn-danger remove-action" @click="removeAppointment">{{$t('action_message.remove')}}</button>
          </div>
        </div>

        <div class="row" v-if="!showAddPanel">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
          </div>
        </div>

    </div>

    </div>
  </div>
</template>

<script>
import { input as BsInput, datepicker as BsDatepicker } from 'vue-strap'
import flatPickr from 'vue-flatpickr-component'
import Multiselect from 'vue-multiselect'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    BsInput,
    BsDatepicker,
    flatPickr,
    Multiselect
  },
  data () {
    return {
      showAddPanel: false,
      editMode: false,
      appointments: [],
      appointment: {},
      q: '',
      paginator: {}
    }
  },
  computed: {
    filtered_appointments () {
      let _appointments = this.appointments
      if (this.q.trim()) {
        _appointments = _appointments.filter(a => a.object.phone.match(new RegExp(this.q)))
      }
      // newest first
      return _appointments.sort((a, b) => a.created_at < b.created_at)
    },
    isPendingView () {
      return this.$route.query.status === 'pending'
    }
  },
  watch: {
    $route (v, o) {
      this.reloadAppointments()
    }
  },
  methods: {
    addAppointment () {
    },
    cancelAddingAppointment () {
    },
    removeAppointment () {
    },
    reloadAppointments (uri) {
      let params = {clinic_id: this.$guser.user.clinic.id}
      if (this.$route.query.status === 'pending') {
        params.status = this.$route.query.status
      }

      this.$http.get(uri || this.$APP_CONFIG.api.appointments(), { params: params, credentials: true }).then(res => {
        this.appointments = res.body.data

        Object.assign(this.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        })
      })
    }
  },
  created () {
    this.reloadAppointments()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";
@import "../../assets/base_pagination";
.appointment-content {
  .card-header {
    display: flex;
    justify-content: center;

    .app-date {
      flex: 1;
    }
  }

  .app-phone {
    color: #aaa;
  }
}
.list-enter-active, .list-leave-active {
    transition: all 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
    opacity: 0;
    transform: translateX(10px);
}

</style>



// WEBPACK FOOTER //
// Appointment.vue?0973b130